import React, {useContext, useState} from 'react';
import {
    Switch,
    Route
} from "react-router-dom";

import {IdleTimeOut} from "../../IdleTimer";

// Pages
import Home from "../Home";
import Resources from "../Resources";
import Tools from "../Tools";
import OperationsContainer from "../OperationsContainer";
import PriorAuthorizationProvider from "../../../contexts/PriorAuthorization/PriorAuthorization.provider";

// Helpers
import {withTracker} from "../../../shared/google-analytics.helper";
import AppContext from "../../../contexts/App/App.context";
import Create from "../Create";
import CreatePa from "../CreatePa";
import ConfirmationModal from '../../../components/Common/ConfirmationModal'

function Authenticated() {
    const {user, provider, npiNumber, showMainModal, mainModalText} = useContext(AppContext);
    const isTest = process.env.REACT_APP_TEST_MODE;
    const [modal, setModal] = useState({open: true, title: "neque sodales ut etiam sit amet nisl purus in mollis nunc sed id semper risus in hendrerit gravida rutrum quisque non tellus orci ac auctor augue mauris augue neque gravida in fermentum et sollicitudin ac orci phasellus egestas tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu feugiat pretium nibh ipsum consequat nisl vel pretium lectus quam id leo in vitae turpis massa sed elementum tempus egestas sed sed risus pretium quam vulputate dignissim suspendisse in est ante in nibh mauris cursus mattis molestie a iaculis at erat pellentesque adipiscing commodo elit at imperdiet dui accumsan sit amet nulla facilisi morbi tempus iaculis urna id volutpat lacus laoreet non curabitur gravida arcu ac tortor dignissim convallis aenean et tortor at risus viverra adipiscing at in tellus integer feugiat scelerisque varius morbi enim nunc faucibus a pellentesque sit amet porttitor eget dolor morbi non arcu risus"})
    return (
        <>
            <Switch>
                <Route exact path="/" component={withTracker(Home, {user, provider, npiNumber})}/>
                <Route exact path="/priorauth/index.html" component={withTracker(Home, {user, provider, npiNumber})}/>
                <Route exact path="/priorauth" component={withTracker(Home, {user, provider, npiNumber})}/>
                <Route exact path="/index.html" component={withTracker(Home, {user, provider, npiNumber})}/>
                <Route exact path="/tools" component={withTracker(Tools)}/>
                <Route exact path="/resources" component={withTracker(Resources)}/>
                <Route exact path="/create" component={withTracker(Create)}/>
                <PriorAuthorizationProvider>
                    <Route exact path="/:operation(inquiry|upload|cancel|update)"
                           component={withTracker(OperationsContainer)}/>
                    <Route exact path="/create/pa" component={withTracker(CreatePa)}/>
                </PriorAuthorizationProvider>
            </Switch>
            <IdleTimeOut disabled={isTest} />
            <ConfirmationModal
                isWarning={false}
                confirm={() => setModal( prev => ({...prev, open: false}))}
                confirmText={'Ok'}
                confirmToolTip={'OK'}
                open={showMainModal && modal.open}
                title={mainModalText}
            />
        </>
    );
}

export default Authenticated;
